/** Thin event hooks for the production Umami script. No tracking exists in staging. */
type EventData = Record<string, string | number | undefined>;
declare global {
  interface Window {
    fileagentUmamiTrack?: (name: string, data?: EventData) => void;
    fileagentUmamiRoute?: () => void;
    fileagentUmamiQueue?: [string, EventData][];
  }
}
export function track(name: string, data: EventData = {}): void {
  try {
    if (!document.querySelector('script[data-fileagent-umami]')) return;
    if (window.fileagentUmamiTrack) window.fileagentUmamiTrack(name, data);
    else if ((window.fileagentUmamiQueue ||= []).length < 40) window.fileagentUmamiQueue.push([name, data]);
  } catch { /* Analytics must never affect a customer action. */ }
}
export function trackRoute(): void { window.fileagentUmamiRoute?.(); }
